import { render, staticRenderFns } from "./contato-suporte.vue?vue&type=template&id=5cacaf50&scoped=true"
import script from "./contato-suporte.vue?vue&type=script&lang=js"
export * from "./contato-suporte.vue?vue&type=script&lang=js"
import style0 from "./contato-suporte.vue?vue&type=style&index=0&id=5cacaf50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacaf50",
  null
  
)

export default component.exports